import { Box, Divider, List, Typography } from '@mui/material'
import SettingsNavigationItem, {
  SettingsNavigationItemProps,
} from './SettingsNavigationItem'

type SettingsNavigationProps = {
  routes: SettingsNavigationItemProps[]
  secondaryRoutes?: SettingsNavigationItemProps[]
  label?: string
  subHeader?: string
  actions?: React.ReactNode
}

export default function SettingsNavigation({
  routes,
  label,
  subHeader,
  actions,
  secondaryRoutes = [],
}: SettingsNavigationProps) {
  return (
    <Box sx={{ m: 3 }}>
      {label && (
        <>
          <Typography
            variant="caption"
            component="h5"
            color="text.secondary"
            sx={{ ml: 1.5 }}
          >
            {label}
          </Typography>
          {subHeader && (
            <Typography
              variant="caption"
              component="h6"
              color="primary.main"
              sx={{ ml: 1.5 }}
            >
              {subHeader}
            </Typography>
          )}
        </>
      )}
      <List disablePadding>
        {routes.map((route) => {
          return <SettingsNavigationItem key={route.to} {...route} />
        })}
        {secondaryRoutes.length > 0 && (
          <>
            <Divider sx={{ my: 2, mx: 1.5 }} />
            {secondaryRoutes.map((route) => {
              return <SettingsNavigationItem key={route.to} {...route} />
            })}
          </>
        )}
      </List>
      {actions}
    </Box>
  )
}
